var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanner"},[_c('video',{attrs:{"id":"camera","autoplay":""}},[_vm._v("You need a camera in order to use this app.")]),_c('div',{attrs:{"id":"snapshotLimitOverlay"}}),_c('canvas',{attrs:{"id":"snapshot"}})])
}]

export { render, staticRenderFns }